import React from 'react';
import PropTypes from 'prop-types';

const HeartIcon = ({ className , filled }) => {
    return (

        <svg
            width="16"
            height="16"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
            className={`fill-current ${className}`}
             // Ensures the color can be changed dynamically 
             fill={filled ? 'currentColor' : 'none'}  // ✅ Ensure correct SVG fill
             >
            <path fillRule="evenodd" clipRule="evenodd" d="M7.56 3.8501C4.90771 3.8501 2.75 6.0108 2.75 8.6901C2.75 11.9406 4.25068 14.545 6.13923 16.48C8.03683 18.4243 10.2799 19.6421 11.6223 20.1003L11.6296 20.1028L11.6296 20.1029C11.6944 20.1257 11.8286 20.1501 12 20.1501C12.1714 20.1501 12.3056 20.1257 12.3704 20.1029L12.3777 20.1003L12.3777 20.1003C13.7201 19.6421 15.9632 18.4243 17.8608 16.48C19.7493 14.545 21.25 11.9406 21.25 8.6901C21.25 6.0108 19.0923 3.8501 16.44 3.8501C14.8778 3.8501 13.477 4.60921 12.6021 5.78726C12.4606 5.97778 12.2373 6.0901 12 6.0901C11.7627 6.0901 11.5394 5.97778 11.3979 5.78726C10.5226 4.60859 9.13147 3.8501 7.56 3.8501ZM1.25 8.6901C1.25 5.18939 4.07229 2.3501 7.56 2.3501C9.29674 2.3501 10.8646 3.05608 12.0003 4.19481C13.1385 3.05574 14.7122 2.3501 16.44 2.3501C19.9277 2.3501 22.75 5.18939 22.75 8.6901C22.75 12.4396 21.0107 15.4002 18.9342 17.5277C16.8683 19.6444 14.4235 20.9862 12.8657 21.5187C12.5914 21.6148 12.2773 21.6501 12 21.6501C11.7227 21.6501 11.4086 21.6148 11.1343 21.5187C9.57655 20.9862 7.13169 19.6444 5.06577 17.5277C2.98932 15.4002 1.25 12.4396 1.25 8.6901Z" fill="currentColor"/>
        </svg>
    );
};

HeartIcon.propTypes = {
    className: PropTypes.string, // Optional: allows passing Tailwind or custom classes
     filled : PropTypes.bool.isRequired,
};

HeartIcon.defaultProps = {
    className: '', // Default to an empty string
};

export default HeartIcon;